<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as SUBJECT_CONTACT_TYPES } from './store'
import ContactCommonFiltersMixin from '../../../components/contact/mixins/ContactCommonFiltersMixin'

export default {
  name: 'SubjectContactCommonFilters',
  mixins: [ContactCommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: SUBJECT_CONTACT_TYPES.GENERIC.organization.subjectcontact.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...SUBJECT_CONTACT_TYPES.GENERIC.organization.subjectcontact.LIST.ACTIONS
    })
  }
}
</script>
